const getCSSVariable = <T extends string, U extends string>({
  light,
  dark,
}: {
  light: T
  dark: U
}) => `var(--is-light-theme, ${light}) var(--is-dark-theme, ${dark})` as const

export { getCSSVariable }
